import { ROUTES_CONFIG } from "./routes-config";
import type { RoutesConfig } from "./types";

const collectPublicPaths = (config: RoutesConfig, prefix = ""): string[] => {
  const paths: string[] = [];
  for (const [segment, route] of Object.entries(config)) {
    const path = `${prefix}${segment}`;
    if (!route.isProtected) {
      paths.push(path);
    }
    if (route.subRoutes) {
      paths.push(...collectPublicPaths(route.subRoutes, path));
    }
  }
  return paths;
};

export const PUBLIC_PATHS = collectPublicPaths(ROUTES_CONFIG);
